import Skeleton from "../../common/Skeleton";

const WatchlistSkeleton = () => {
  return (
    <>
      {[...Array(10)].map((_, index) => (
        <tr
          key={index}
          className="border-b border-gray-100 dark:border-gray-800"
        >
          {/* Stock */}
          <td className="py-3 px-6 whitespace-nowrap">
            <div className="flex items-center gap-3">
              <Skeleton className="w-3 h-3 rounded-full" />
              <div>
                <Skeleton className="w-24 h-5 rounded mb-1" />
                <Skeleton className="w-16 h-3 rounded" />
              </div>
            </div>
          </td>
          {/* Added On */}
          <td className="py-3 px-6 text-center">
            <Skeleton className="w-24 h-4 mx-auto rounded" />
          </td>
          {/* Current Price */}
          <td className="py-3 px-6 text-center">
            <Skeleton className="w-20 h-4 mx-auto rounded" />
            <Skeleton className="w-16 h-3 mx-auto rounded mt-1" />
          </td>
          {/* Alert Price */}
          <td className="py-3 px-6 text-center">
            <Skeleton className="w-16 h-4 mx-auto rounded" />
          </td>
          {/* Change */}
          <td className="py-3 px-6 text-center">
            <div className="flex flex-col items-center gap-1">
              <Skeleton className="w-16 h-4 rounded" />
              <Skeleton className="w-12 h-3 rounded" />
            </div>
          </td>
          {/* Alert Status */}
          <td className="py-3 px-6 text-center">
            <Skeleton className="w-16 h-6 mx-auto rounded-full" />
          </td>
          {/* Frequency */}
          <td className="py-3 px-6 text-center">
            <Skeleton className="w-16 h-6 mx-auto rounded-full" />
          </td>
          {/* Notes */}
          <td className="py-3 px-6 text-center">
            <Skeleton className="w-24 h-4 mx-auto rounded" />
          </td>
          {/* Actions */}
          <td className="py-3 px-6 text-center">
            <div className="flex justify-center gap-2">
              <Skeleton className="w-8 h-8 rounded-full" />
              <Skeleton className="w-8 h-8 rounded-full" />
              <Skeleton className="w-8 h-8 rounded-full" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default WatchlistSkeleton;
